
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    balance: 'Home',
    cases: 'Cases',
    games: 'Games',
    inventory: 'Inventory',
    referrals: 'Friends',
    profile: 'Profile',
    shop: 'Shop',
    menu: 'Menu',
    settings: 'Settings',
    band: 'SHOT BAND',
  },
  ru: {
    balance: 'Главная',
    cases: 'Кейсы',
    games: 'Игры',
    inventory: 'Инвентарь',
    referrals: 'Друзья',
    profile: 'Профиль',
    shop: 'Магазин',
    menu: 'Меню',
    settings: 'Настройки',
    band: 'SHOT BAND',
  },
  uz: {
    balance: 'Bosh sahifa',
    cases: 'Keyslar',
    games: "O'yinlar",
    inventory: 'Inventar',
    referrals: "Do'stlar",
    profile: 'Profil',
    shop: "Do'kon",
    menu: 'Menyu',
    settings: 'Sozlamalar',
    band: 'SHOT BAND',
  },
});
